import axios from "axios";

export async function requestGetInvoiceDetailsWithToken(token) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/public/invoice/${token}`);
}

export async function requestPayInvoiceWithToken(token, payload) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/public/invoice/${token}/pay`, payload);
}
